import React, { useEffect, useState } from 'react';
import CropImageField from '@components/common/form/CropImageField';
import { AppConstants, STATUS_ACTIVE } from '@constants';
import apiConfig from '@constants/apiConfig';
import { commonStatus, statusOptions } from '@constants/masterData';
import useFetch from '@hooks/useFetch';
import useTranslate from '@hooks/useTranslate';
import { SelectField, TextField } from '@itz/react-cms-element';
import { commonMessage } from '@locales/intl';
import { showErrorMessage } from '@services/notifyService';
import { handleRemoveImage } from '@utils';
import { Col, Form, Row } from 'antd';

const DriverForm = ({ detail, form, onSave, actions, isEditing }) => {
    const translate = useTranslate();
    const statusValues = translate.formatKeys(statusOptions, ['label']);
    const [imageUrl, setImageUrl] = useState(null);
    const { execute: executeUpFile } = useFetch(apiConfig.file.upload);

    const uploadFile = (file) => {
        executeUpFile({
            data: {
                type: 'AVATAR',
                file: file,
            },
            onCompleted: (response) => {
                if (response.result === true) {
                    setImageUrl(response.data.filePath);
                }
            },
            onError: (error) => {
                if (error.code == 'ERROR-FILE-FORMAT-INVALID') {
                    showErrorMessage(translate.formatMessage(commonMessage.error), translate);
                }
            },
        });
    };

    useEffect(() => {
        if (detail && isEditing) {
            form.setFieldsValue({ ...detail });
            setImageUrl(detail.avatarPath);
        } else {
            form.resetFields();
            form.setFieldsValue({ status: STATUS_ACTIVE });
            setImageUrl(null);
        }
    }, [detail, isEditing]);

    const handleSubmit = (values) => {
        if (detail) {
            values.id = detail.id;
        }
        values.avatarPath = imageUrl;
        if (!isEditing) {
            values.status = STATUS_ACTIVE;
        }
        onSave(values);
    };

    return (
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
            <Row gutter={16}>
                <Col span={12}>
                    <CropImageField
                        name="avatarPath"
                        label={translate.formatMessage(commonMessage.avatar)}
                        imageUrl={imageUrl && `${AppConstants.contentRootUrl}${imageUrl}`}
                        uploadFile={uploadFile}
                        handleRemoveImage={() => handleRemoveImage(setImageUrl, form)}
                        aspect={1}
                        style={{ width: 170 }}
                    />
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={12}>
                    <TextField name="username" label={translate.formatMessage(commonMessage.username)} required />
                </Col>
                <Col span={12}>
                    <TextField name="password" label={translate.formatMessage(commonMessage.password)}  required={!isEditing} />
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={12}>
                    <TextField name="fullName" label={translate.formatMessage(commonMessage.fullName)} required />
                </Col>
                <Col span={12}>
                    <TextField name="phone" label={translate.formatMessage(commonMessage.phone)} required />
                </Col>
            </Row>
            {isEditing && (
                <Row gutter={16}>
                    <Col span={12}>
                        <SelectField
                            name="status"
                            label={translate.formatMessage(commonMessage.status)}
                            disabled={!isEditing}
                            options={statusValues}
                            required
                        />
                    </Col>
                </Row>
            )}
            {actions}
        </Form>
    );
};

export default DriverForm;
